"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findBlockCheckpointId = void 0;
var bignumber_1 = require("@ethersproject/bignumber");
var checkBlockInCheckpoint = function (checkpointManager, targetBlockNumber, checkpointId) { return __awaiter(void 0, void 0, void 0, function () {
    var headerBlock, headerStart, headerEnd;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, checkpointManager.headerBlocks(checkpointId)];
            case 1:
                headerBlock = _a.sent();
                headerStart = bignumber_1.BigNumber.from(headerBlock.start);
                headerEnd = bignumber_1.BigNumber.from(headerBlock.end);
                if (headerStart.gt(targetBlockNumber)) {
                    // targetBlockNumber was checkpointed before this headerBlock
                    return [2 /*return*/, -1];
                }
                if (headerEnd.lt(targetBlockNumber)) {
                    // targetBlockNumber was checkpointed after this headerBlock
                    return [2 /*return*/, 1];
                }
                // targetBlockNumber is between the upper and lower bounds of the headerBlock, we found our answer
                return [2 /*return*/, 0];
        }
    });
}); };
/**
 * Searches for checkpoint of a particular childChain block on rootChainManager contract using binary search
 * @param checkpointManager        Ethers contract object for CheckpointManager contract
 * @param blockNumber              Blocknumber on the matic chain of which we are searching for the checkpoint of
 * @returns A BigNumber containing the id of the checkpoint which contains the specified block
 */
exports.findBlockCheckpointId = function (checkpointManager, childBlockNumber, checkpointIdInterval) {
    if (checkpointIdInterval === void 0) { checkpointIdInterval = bignumber_1.BigNumber.from(10000); }
    return __awaiter(void 0, void 0, void 0, function () {
        var start, latestCheckpointId, end, mid, checkpointStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // eslint-disable-next-line no-param-reassign
                    childBlockNumber = bignumber_1.BigNumber.from(childBlockNumber);
                    start = bignumber_1.BigNumber.from(1);
                    // Shortcut: If block is newer than last checkpoint of 2020 then bring forward start to then
                    // Shaves off a couple of seconds for recent withdrawals
                    if (childBlockNumber.gte(9010326)) {
                        start = bignumber_1.BigNumber.from(91490000).div(checkpointIdInterval);
                    }
                    return [4 /*yield*/, checkpointManager.currentHeaderBlock()];
                case 1:
                    latestCheckpointId = _a.sent();
                    end = bignumber_1.BigNumber.from(latestCheckpointId).div(checkpointIdInterval);
                    if (start.gt(end)) {
                        throw new Error("start block is greater than end block");
                    }
                    _a.label = 2;
                case 2:
                    if (!true) return [3 /*break*/, 4];
                    if (start.eq(end)) {
                        return [2 /*return*/, start.mul(checkpointIdInterval)];
                    }
                    mid = start.add(end).div(2);
                    return [4 /*yield*/, checkBlockInCheckpoint(checkpointManager, childBlockNumber, mid.mul(checkpointIdInterval))];
                case 3:
                    checkpointStatus = _a.sent();
                    switch (checkpointStatus) {
                        case 0:
                            // childBlockNumber is in this checkpoint, we found our answer
                            return [2 /*return*/, mid.mul(checkpointIdInterval)];
                        case -1:
                            // childBlockNumber was checkpointed before this checkpoint
                            end = mid.sub(1);
                            break;
                        case 1:
                            // childBlockNumber was checkpointed after this checkpoint
                            start = mid.add(1);
                            break;
                        default:
                            throw new Error("Error finding correct checkpoint ID");
                    }
                    return [3 /*break*/, 2];
                case 4: return [2 /*return*/];
            }
        });
    });
};
